export default __webpack_public_path__ + "static/part3_3-64c7cba11f43d394caff811bc57903f2.png";